module.exports = __webpack_public_path__ + "img/consul-05z.1bcc668e.jpg";